import parsePhoneNumberFromString from 'libphonenumber-js';

export const spreadState = (state, obj) => {
  Object.keys(obj).forEach((key) => {
    return (state[key] = obj[key]);
  });
};

export const createNewField = (initialValue) => {
  return { value: initialValue || '', touched: false, hasError: false };
};

export const setAddressFromApi = (state, addressType, address) => {
  if (addressType === 'shipping') {
    state.email.touched = true;
    state.email.value = address.email || '';
  }
  state[addressType].firstName.touched = true;
  state[addressType].lastName.touched = true;
  state[addressType].address.touched = true;
  state[addressType].address2.touched = true;
  state[addressType].zipCode.touched = true;
  state[addressType].city.touched = true;
  state[addressType].state.touched = true;
  state[addressType].country.touched = true;
  if (address.phone && state[addressType].phone) state[addressType].phone.touched = true;

  state[addressType].firstName.value = address.firstName || '';
  state[addressType].lastName.value = address.lastName || '';
  state[addressType].address.value = address.streetName || '';
  state[addressType].address2.value = address.additionalStreetInfo || '';
  state[addressType].zipCode.value = address.postalCode || '';
  state[addressType].city.value = address.city || '';
  state[addressType].state.value = address.state || '';
  state[addressType].country.value = address.countryName || '';

  if (address.phone) {
    formatPhoneNumber(state, addressType, address.phone);
    if (addressType == 'shipping' && state[addressType].phone) state[addressType].phone.touched = true;
  }
};

export const formatPhoneNumber = (state, addressType, phoneNumber) => {
  if (state[addressType]?.phone) {
    if (phoneNumber?.startsWith('+')) {
      let parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);
      if (!parsedPhoneNumber.isValid()) return;

      state[addressType].phone.value = phoneNumber.replace('+' + parsedPhoneNumber.countryCallingCode, '');
      state[addressType].phoneCountryCode.value = parsedPhoneNumber.country;
    } else if (phoneNumber?.startsWith('0')) {
      state[addressType].phone.value = phoneNumber.substring(1);
    } else {
      state[addressType].phone.value = phoneNumber || '';
    }
  }
};
